import _ from 'lodash';

import { UsStatesList } from './usStates';

export const stateOptions = _.map(UsStatesList, (option) => ({ value: option, label: option }));
